import axios from 'axios'
import lstModules from 'common/json/lstModules.json'
var tokenid = localStorage.getItem('tokenid')
var httpURL = lstModules['ptm'].url + ':' + lstModules['ptm'].port
var httpURLCommon = lstModules['main'].url + ':' + lstModules['main'].port

function getAchievementListSvc(ptmId, cb) {
  var status = 'Success'
  var obj = { status: status, message: '' }

  axios({
    url: httpURLCommon + '/sms/ptm_plan/achievement/list',
    method: 'POST',
    params: { ptmId: ptmId },
    headers: { tokenid: tokenid },
    withCredentials: true
  })
    .then(response => {
      // console.log(Response.data)
      obj.message = response.data.SvcMsg
      obj.status = response.data.SvcStatus
      obj.lstPtmAchievement = response.data.lstPtmAchievement
      cb(obj)
    })
    .catch(error => {
      obj.status = 'Exception'
      obj.message = error
      cb({}, obj)
    })
}

function saveAchievementSvc(ptmAchievement, ptmId, cb) {
  var status = 'Success'
  var obj = { status: status, message: '', ptmId:ptmId }
  var formData = new FormData()
  formData.append("ptmAchievement", JSON.stringify(ptmAchievement));

  axios({
    url: httpURLCommon + '/sms/ptm_plan/achievement/save',
    //queryString.stringify({ screenId: screenId, cellId: cellId, sub1: sub1 }),
    method: 'POST',
    headers: { tokenid: tokenid },
    withCredentials: true,
    data: formData
  })
    .then(response => {
      // console.log( 'message:' + response.data.SvcMsg + 'status:' + response.data.SvcStatus  )
      obj.message = response.data.SvcMsg
      obj.status = response.data.SvcStatus
      cb(obj)
    })
    .catch(error => {
      obj.status = 'Exception'
      obj.message = error
      cb({}, obj)
    })
}
function deleteAchievementSvc(ptmId, cb) {
  var status = 'Success'
  var obj = { status: status, message: '', ptmId:ptmId }

  axios({
    url: httpURLCommon + '/sms/ptm_plan/achievement/remove',
    method: 'POST',
    headers: { tokenid: tokenid },
    withCredentials: true,
    params: { ptmId: ptmId }
  })
    .then(response => {
      // console.log( 'message:' + response.data.SvcMsg + 'status:' + response.data.SvcStatus  )
      obj.message = response.data.SvcMsg
      obj.status = response.data.SvcStatus
      cb(obj)
    })
    .catch(error => {
      obj.status = 'Exception'
      obj.message = error
      cb({}, obj)
    })
}

export { getAchievementListSvc, saveAchievementSvc, deleteAchievementSvc }
